import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';

import { MessageDescriptorPropType } from '../../../../../../../prop-types/intl';
import { createColumnDefinitionBuilder } from '../../../../../../../components/items-table/create-column-definition-builder';

import style from '../../style.module.less';

const DeleteItemColumnId = 'delete';

const deleteItemDataBuilder = (item) => ({
  id: item.id,
  readonly: item.readonly,
});

// TODO: we need to find a better trash icon here that's more in line with designs
const DeleteItem = ({ value: item, onRowDelete, disabled = false }) => {
  const onClick = useCallback(() => {
    onRowDelete(item.id);
  }, [item.id, onRowDelete]);

  return (
    <Button className={style['delete-button']} disabled={disabled} onClick={onClick} theme='unstyled'>
      <FontAwesomeIcon icon={faTrash} />
    </Button>
  );
};

DeleteItem.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    readonly: PropTypes.shape({
      code: PropTypes.string,
      reasonMessageDescriptor: MessageDescriptorPropType,
    }),
  }).isRequired,
  onRowDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const createDeleteItemColumnDefinition = createColumnDefinitionBuilder({
  header: '',
  accessor: DeleteItemColumnId,
  cell: DeleteItem,
  className: style.column,
});

export { DeleteItemColumnId, deleteItemDataBuilder, createDeleteItemColumnDefinition };
